module.exports = __webpack_public_path__ + "img/html5-logo.8cce7261.png";